import { JsonObject, JsonProperty } from 'json2typescript';
import { ClientDataApiRestInterface } from '../interfaces/client-data-apirest.interface';

@JsonObject('ClientDataApiRest')
export class ClientDataApiRest implements ClientDataApiRestInterface {
  AcceptMarketing?: boolean;
  Age?: number;
  Agent?: any;
  AllowTransfers?: boolean;
  BirthDay?: string;
  ClientCode?: string;
  ClientCodeView?: string;
  ClientModifiedGroups?: string;
  CountryOfResidence?: string;
  DocExpirationDate?: string;
  DocId?: string;
  DocType?: string;
  Email?: string;
  InvestorProfile?: InvestorProfile;
  IsFavourite?: boolean;
  LegalGuardians?: any;
  MarketingCampaign?: string;
  Mifi2Category?: string;
  Mifi2CategoryCode?: string;
  MinorsandDisableds?: any;
  Name?: string;
  Nature?: string;
  NatureId?: string;
  Notifications?: number;
  OnboardingStatus?: string;
  OnboardingProcessStatus?: string;
  OnboardingNextAction?: string;
  Phone?: string;
  PotentialClient?: boolean;
  RegisteredCountry?: string;
  SegmentCode?: string;
  SegmentName?: string;
  StatusDataClient?: string;
  Surname?: string;
  TotalBalance?: number;
  Type?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('InvestorProfile')
export class InvestorProfile {
  AllowReprofile?: boolean;
  ConvenienceGroups?: ConvenienceGroup[];
  MifidCompetenceId?: number;
  MifidCompetenceName?: string;
  MifidCompetenceScore?: number;
  ProfileId?: string;
  ProfileName?: string;
  ProfileScore?: number;
  ProfileTestSignatureStatus?: string;
  ProfileTestSignatureType?: string;
  ProfileTimeHorizon?: string;
  TestDate?: string;
  TestExpirationDate?: string;
  TestExpired?: boolean;
  TestId?: string;
  TestIdView?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ConvenienceGroup')
export class ConvenienceGroup {
  GroupId?: string;
  GroupName?: string;
  IsValid?: boolean;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
